import type { ReactElement } from 'react';
import { Component as CartIcon } from 'icons/icon-ui--cart-small.svg';
import { get, patch, post, put } from 'utils/network';
import { ApiRoute } from 'config';
import React from 'react';
import CartModel, { ICart } from 'models/Cart';
import IApiResponse from 'models/IApiResponse';
import useCurrentUser from '../../../hooks/useCurrentUser';
import LTOBannerAddToCartButton from '../../Lto/LTOBannerAddToCartButton';

type Props = {
  isEditCartPage?: boolean;
  hasCart?: boolean;
  skippedCartId?: number | undefined;
  isLtoMenuSkipped?: boolean;
  isLtoMenuUnskipped?: boolean;
  isReactivatedUser?: boolean;
  setUnskippingLtoMenu?: (unskippingLtoMenu: boolean) => void;
  setIsReactivatedUser?: (isReactivatedUser: boolean) => void;
};

function ThanksgivingBanner({
  isEditCartPage,
  hasCart = false,
  skippedCartId,
  isLtoMenuSkipped = false,
  isLtoMenuUnskipped = false,
  isReactivatedUser = false,
  setUnskippingLtoMenu,
  setIsReactivatedUser,
} : Props): ReactElement {
  const { currentUser } = useCurrentUser();
  const OnLearnMore = async () => {
    window.location.href = '/lto/thanksgiving';
  };
  const handleClickForDeactivatedUser = async () => {
    if (currentUser?.subscription?.status === 'suspended') {
      window.location.href = '/payment-method';
      return;
    }
    const statuses = ['returning', 'paused', 'cancelled'];
    if (statuses.includes(currentUser?.subscription?.status)) {
      const response = await patch(ApiRoute.REACTIVATE);
      if (response.ok && setIsReactivatedUser) {
        setIsReactivatedUser(true);
      }
    }
  };

  const handleUnskip = async () => {
    if (skippedCartId) {
      const response = await post(`${ApiRoute.CARTS}/${skippedCartId}/unskip`);
      const { parsedBody, ok } = await get<ICart>(`${ApiRoute.CARTS}/${skippedCartId}`);
      if (parsedBody && ok) {
        const thanksgivingCart = new CartModel(parsedBody);
        const ltoBoxItems = thanksgivingCart.menu_items.filter(
          (item) => item.sku?.is_lto_box,
        );
        const ltoBoxItem = ltoBoxItems[0];
        await put<IApiResponse>(
          `${ApiRoute.CARTS}/${skippedCartId}`,
          {
            cart: {
              cart_items: [
                ...thanksgivingCart.selectedItems.map(({ sku, quantity }) => ({
                  sku_id: sku.id,
                  quantity,
                })),
                { sku_id: ltoBoxItem.sku.id, quantity: 1 },
              ],
            },
          },
        );
      }
      if (response.ok && setUnskippingLtoMenu) {
        // cart has been unskipped, but we need to reload the cart with updated item quantities
        setUnskippingLtoMenu(true);
      }
    }
  };

  return (
    <div
      className="c-upcoming-menu__thanksgivingBanner__card }"
      style={isEditCartPage ? { padding: 0, maxHeight: '100%' } : {}}
    >
      <div
        className="c-upcoming-menu__thanksgivingBanner__image"
        style={isEditCartPage ? { height: '100%' } : {}}
      >
        <div className="c-upcoming-menu__thanksgivingBanner__word_container">
          <h1 className="c-upcoming-menu__thanksgivingBanner__heading">
            Thanksgiving Box
          </h1>
          <h3 className="c-upcoming-menu__thanksgivingBanner__subtitle">
            Simplify the holiday this year with plant-based meal kits & sides
          </h3>
          <div
            className="c-upcoming-menu__thanksgivingBanner__buttonContainer"
            style={isEditCartPage ? { flexDirection: 'column', gap: '0px' } : {}}
          >
            <div>
              {hasCart
                ? (
                  <LTOBannerAddToCartButton
                    isLtoMenuUnskipped={isLtoMenuUnskipped}
                    isReactivatedUser={isReactivatedUser}
                    isEditCartPage={isEditCartPage}
                  />
                ) : (
                  <button
                    type="button"
                    className="c-upcoming-menu__thanksgivingBanner__addtoCartButton"
                    style={isEditCartPage ? { paddingBottom: '12px' } : {}}
                    onClick={isLtoMenuSkipped ? handleUnskip : handleClickForDeactivatedUser}
                  >
                    <CartIcon />
                    Add to Cart
                  </button>
                )}
              <em className="c-upcoming-menu__thanksgivingBanner__reserveBy">
                Reserve by 11/18!
              </em>
            </div>
            <button
              type="button"
              className="c-upcoming-menu__thanksgivingBanner__learnMoreButton"
              onClick={OnLearnMore}
            >
              Learn More
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ThanksgivingBanner;
